import {post,get, nPost} from '../../libs/ajax.js'

export default {
    /* 素材库 素材管理*/

    // 素材库 筛选 远程搜索部分枚举值
    postSearchStoreMethodOptions:(data,options) => {
        return nPost('/material_storehouse/get_search_list', data, options);
    },
    // 素材库 下拉部分枚举值
    getSearchWorkOrderOptions:(data,options) => {
        return get('/work_order/search_config', data, options);
    },
    // 素材库 投放 版位 场景
    getSearchDeliveryOptions:(data,options) => {
        return get('/work_order/get_delivery_list', data, options);
    },
    // 素材库 素材列表
    getStoreList: (data, options) => {
        return post('/material_storehouse/get_list', data, options);
    },
    // 素材库 - 批量下载
    postWorkOrderDownLoad:(data,options) => {
        return post('/material_storehouse/batch_download', data, options);
    },
    // 素材库 - 批量下载
    getOnlyDownLoad:(data,options) => {
        return get('/material_storehouse/download', data, options);
    },
    // 素材库 - 预览
    getPreview:(data,options) => {
        return get('/material_storehouse/preview', data, options);
    },
    // 工单 -预览
    getOrderPreview:(data,options) => {
        return get('/order_task/detail_material/preview', data, options);
    },
    // 素材库 - 删除
    postStoreDel:(data,options) => {
        return post('/material_storehouse/delete', data, options);
    },
}
